export default [
  {
    name: 'DOMOV',
    icon: 't-2-ikone domov',
    path: '/Domov/NaslovnaStran'
  },
  {
    name: 'MOJ T-2 ID',
    icon: 't-2-ikone profil',
    collapsed: true,
    children: [{
      name: 'Uredi T-2 ID',
      path: '/Mojprofil/Osnovno'
    },
    {
      name: 'Varnost',
      path: '/Mojprofil/Varnost'
    },
    {
      name: 'Nastavitve Moj T-2',
      path: '/Mojprofil/NastavitveMojT2'
    },
    {
      name: 'Družabna omrežja',
      path: '/Mojprofil/Druzabno'
    }
    ]
  },
  {
    name: 'T-2 NAROČNINE',
    icon: 't-2-ikone narocnine',
    collapsed: true,
    children: [{
      name: 'Moje naročnine',
      path: '/Mojprofil/Narocnine'
    },
    {
      name: 'MOJ KLUB',
      path: '/Mojprofil/T2klub'
    },
    {
      name: 'Uporabniki in pravice',
      path: '/MojT2/UporabnikiInPravice'
    },
    {
      name: 'Računi',
      path: '/MojT2/Racuni'
    },
    {
      name: 'ePoslovanje',
      path: '/MojT2/Eposlovanje'
    },
    {
      name: 'Dokumenti',
      path: '/MojT2/Dokumenti'
    },
    {
      name: 'Soglasja',
      path: '/MojT2/OsebniPodatkiInSoglasja'
    },
    {
      name: 'Predplačniške storitve',
      path: '/MojT2/PredplacniskeStoritve'
    }
    ]
  },
  {
    name: 'PORABA',
    icon: 't-2-ikone poraba',
    collapsed: true,
    children: [{
      name: 'Telefonija',
      path: '/Poraba/PorabaTelefonija'
    },
    {
      name: 'Televizija',
      path: '/Poraba/PorabaTelevizija'
    },
    {
      name: 'T-2 Hramba',
      path: '/Poraba/PorabaHramba'
    }
    ]
  },
  {
    name: 'NAROČI',
    icon: 't-2-ikone naroci',
    collapsed: true,
    children: [{
      name: 'T-2 Paketi',
      path: '/Naroci/NarociT2Paket'
    },
    {
      name: 'Mobilna telefonija',
      path: '/Naroci/NarociMobilnaTelefonija'
    },
    {
      name: 'Televizija',
      path: '/Naroci/NarociTelevizija'
    },
    {
      name: 'Smart TV',
      path: '/Naroci/TVsmart'
    },
    {
      name: 'Internet',
      path: '/Naroci/NarociInternet'
    },
    {
      name: 'Varnostna zaščita',
      path: '/Naroci/VarnostnaZascita'
    },
    {
      name: 'Telefonija',
      path: '/Naroci/NarociTelefonija'
    },
    {
      name: 'Horizont',
      path: '/Naroci/NarociHramba'
    }
    ]
  },
  {
    name: 'NASTAVITVE',
    icon: 't-2-ikone nastavitve',
    collapsed: true,
    children: [{
      name: 'Telefonija',
      path: '/Nastavitve/NastavitveTelefonija'
    },
    {
      name: 'Televizija',
      path: '/Nastavitve/NastavitveTelevizija'
    },
    {
      name: 'Mrežna oprema',
      path: '/Nastavitve/NastavitveMreznaOprema'
    },
    {
      name: 'Elektronska pošta',
      path: '/Nastavitve/NastavitveElektronskaPosta'
    },
    {
      name: 'Spletna predstavitev',
      path: '/Nastavitve/SpletnaPredstavitev'
    },
    {
      name: 'SSO Clienti',
      path: '/Nastavitve/ClientServise'
    },
    {
      name: 'T2 Cloud',
      path: '/Nastavitve/T2Cloud'
    }
    ]
  },
  {
    name: 'UPORABNIŠKI KOTIČEK',
    icon: 't-2-ikone uporabnski-koticek',
    collapsed: true,
    children: [{
      name: 'O Mojem T-2',
      path: '/UporabniskiKoticek/OMojemT2'
    },
    {
      name: 'T-2 Novice',
      path: '/UporabniskiKoticek/UporabneStrani'
    },
    {
      name: 'T-2 Aplikacije',
      path: '/UporabniskiKoticek/T2Aplikacije'
    },
    {
      name: 'Pošlji SMS',
      path: '/UporabniskiKoticek/PosljiSms'
    },
    {
      name: 'Pripelji prijatelja',
      path: '/UporabniskiKoticek/Ambasador'
    }
    ]
  },
  {
    name: 'POSLOVALNICE',
    icon: 'poslovalnice-ikona',
    path: '/Poslovalnice'
  }
]



// WEBPACK FOOTER //
// ./src/sidebarLinks.js